/**
 * Create the redirect modal.
 * 
 * @param {object} options 
 * 
 * @returns {object}
 */
const CreateRedirectModal = options => {
    const close = document.querySelector(options.selectors.close);
    const modalContent = document.querySelector(options.selectors.content);
    const modal = document.querySelector(options.selectors.modal);
    const redirectLinks = Array.from(document.querySelectorAll(options.selectors.redirectLink));
    const body = document.querySelector('body');
    const action = {
        open: 'open',
        close: 'close'
    };
    let timeout = parseInt(modal.dataset.timeout) * 1000;
    let url = undefined;

    /**
     * Takes in an array of required items and confirms whether everything exists.
     * 
     * @param {array} items 
     * 
     * @returns {boolean}
     */
    const __exists = items => {
        let valid = true;

        items.forEach(item => {
            if (item === undefined || item === null || item.length === 0) {
                valid = false;
            }
        });

        return valid;
    };

    /**
     * Redirect the user to the url they clicked on initially.
     * 
     * @returns {void}
     */
    const __redirect = () => {
        window.location = url;
    };

    /**
     * Toggle the modal on click.
     * 
     * @param {object} link
     * 
     * @return {void}
     */
    const __toggleModal = (action, content) => {
        body.style.overflow = 'hidden';

        switch (action) {
            case 'open':
                if (content !== null) {
                    modalContent.innerHTML = content;
                    modal.classList.add(options.classes.active);
                    modal.setAttribute('aria-hidden', false);
                    modal.tabIndex = 0;

                    setTimeout(() => {
                        __redirect();
                    }, timeout);
                } else {
                    __redirect();
                }
                break;

            case 'close':
                modal.setAttribute('aria-hidden', true);
                modal.classList.remove(options.classes.active);
                modal.tabIndex = -1;
                __redirect();
                break;
        }

    };

    /**
     * Bind event listeners to links.
     * 
     * @return {void}
     */
    const __bind = () => {
        const closeElements = [modal, close];

        redirectLinks.forEach(redirectLink => {
            redirectLink.addEventListener('click', e => {
                e.preventDefault();

                let linkContent = redirectLink.dataset.content ? redirectLink.dataset.content : null;
                url = redirectLink.dataset.redirectUrl ? redirectLink.dataset.redirectUrl : redirectLink.href;

                __toggleModal(action.open, linkContent);
            });
        });

        closeElements.forEach(closeEl => {
            closeEl.addEventListener('click', e => {
                e.preventDefault();

                if (e.target.classList.contains(options.classes.modal) ||
                    e.target.classList.contains(options.classes.close)
                ) {
                    __toggleModal(action.close, null);
                }
            });
        })
    };

    /**
     * Publicly exposed init function.
     */
    const init = () => {
        const requiredItems = [modal, modalContent, redirectLinks, body];

        if (__exists(requiredItems)) {
            __bind();
        } else {
            console.warn('CreateRedirectModal not initialised.');
        }
    };

    /**
     * Only expose the init function to global scope.
     */
    return Object.freeze({
        init
    });
};

// Setup the necessary modal classes we need to target.
const RedirectModal = new CreateRedirectModal({
    selectors: {
        close: '.redirect-modal__close',
        content: '.redirect-modal__content',
        modal: '.redirect-modal',
        redirectLink: '.redirect-modal-link',
    },
    classes: {
        active: 'active',
        close: 'redirect-modal__close',
        modal: 'redirect-modal',
    }
});

// Once the DOM is loaded, init our custom redirect modal .
window.addEventListener('load', () => {
    RedirectModal.init();
});